import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box"
import Tooltip from '@mui/material/Tooltip';
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";

import AddIcon from '@mui/icons-material/Add';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import RemoveIcon from '@mui/icons-material/Remove';
import ResetIcon from "@mui/icons-material/RotateLeft";
import RunIcon from "@mui/icons-material/PlayArrow";
import SaveIcon from '@mui/icons-material/Save';
import SettingsIcon from '@mui/icons-material/Settings';
import TableViewOutlinedIcon from '@mui/icons-material/TableViewOutlined';
import UpdateIcon from '@mui/icons-material/Update';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { DisplaySettings } from "@mui/icons-material";
import FilterAlt from '@mui/icons-material/FilterAlt';

const AddButton = ({ label = "add", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="info" size="small" {...others}>
          <AddIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const BulkValueUpdateButton = ({ label = "bulkValueUpdate", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="black" size="small" {...others}>
          <UpdateIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const CalculationButton = ({ label = "calculation", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="black" size="small" {...others}>
          <CalculateOutlinedIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const DetailButton = ({ label = "calculation", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="black" size="small" {...others}>
          <DisplaySettings />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const CheckButton = ({ label = "check", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="success" size="small" {...others}>
          <CheckCircleOutlineIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const CreateButton = ({ label = "create", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="info" size="small" {...others}>
          <CreateNewFolderOutlinedIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const CopyButton = ({ label = "copy", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="black" size="small" {...others}>
          <ContentCopyOutlinedIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const DateRangeButton = ({ label = "period", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="black" size="small" {...others}>
          <DateRangeOutlinedIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const DeleteButton = ({ label = "delete", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="error" size="small" {...others}>
          <DeleteIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const DownloadButton = ({ label = "export", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="black" size="small" {...others}>
          <FileDownloadOutlinedIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const EditButton = ({ label = "edit", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="info" size="small" {...others}>
          <EditIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const LockButton = ({ label = "lock", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="black" size="small" {...others}>
          <LockIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const RemoveButton = ({ label = "delete", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="error" size="small" {...others}>
          <RemoveIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

/*
 * 목록에서 항목 하나를 빼는 동그라미 X 버튼.
 *   RemoveButton(−, error)은 그리드 툴바에서 "선택 행 삭제"를 뜻하고 90여 화면이 그 뜻으로 쓴다.
 *   이건 행 끝에 붙어 그 행만 목록 밖으로 내보내는 가벼운 동작이라, 툴바 버튼보다 작고(18px)
 *   회색이다 — 행마다 하나씩 붙는 자리에서 빨간 아이콘은 목록을 경고문처럼 보이게 한다.
 *   부르는 쪽이 뜻에 맞는 label 을 준다(예: label="remove").
 */
const CloseButton = ({ label = "close", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton
          aria-label={label}
          size="small"
          sx={{ p: 0.25, color: "text.secondary", "&:hover": { color: "text.primary" } }}
          {...others}
        >
          <HighlightOffIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const ResetButton = ({ label = "reset", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="black" size="small" {...others}>
          <ResetIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const ResultButton = ({ label = "result", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="black" size="small" {...others}>
          <TableViewOutlinedIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const RunButton = ({ label = "run", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="success" size="small" {...others}>
          <RunIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const RunningButton = ({ label = "running", disabled = true, ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton disabled={disabled}>
          <CircularProgress aria-label={label} color="black" size={"18px"} {...others} />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const SaveButton = ({ label = "save", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="success" size="small"  {...others}>
          <SaveIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

// color: 설정 여부를 색으로 구분하고 싶을 때 넘긴다(미설정=기본 black, 설정됨=info)
const SettingsButton = ({ label = "settings", color = "black", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color={color} size="small"  {...others}>
          <SettingsIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const FullScreenButton = ({ fullScreen, setFullScreen, screenId, setScreenId, label = "fullscreen", ...others }) => {
  const { t } = useTranslation();
  const tooltipLabel = fullScreen ? "fullScreenOff" : "fullScreen";

  const onClickFullScreen = () => {
    if (screenId && setScreenId) {
      setScreenId(screenId);
    }
    setFullScreen(!fullScreen);
  }

  return (
    <Tooltip title={t(tooltipLabel)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="black" size="small" onClick={() => onClickFullScreen()} {...others}>
          {fullScreen ? <CloseFullscreenIcon sx={{ width: "20px", height: "20px" }} /> : <OpenInFullIcon sx={{ width: "15px", height: "15px" }} />}
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const UnlockButton = ({ label = "unlock", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="black" size="small" {...others}>
          <LockOpenIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const UploadButton = ({ label = "import", ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <Box component={"span"}>
        <IconButton aria-label={label} color="black" size="small"  {...others}>
          <FileUploadOutlinedIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
}

const FilterButton = ({ label = "filter", advancedFilterColor, ...others }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(label)}>
      <IconButton size="small" variant="contained" color={advancedFilterColor}  {...others}>
        <FilterAlt />
      </IconButton>
    </Tooltip>
  );
}

export {
  AddButton,
  BulkValueUpdateButton,
  CalculationButton, CheckButton, CopyButton, CloseButton, CreateButton,
  DateRangeButton,
  DeleteButton,
  DownloadButton,
  EditButton,
  LockButton,
  RemoveButton, ResetButton, ResultButton, RunButton, RunningButton,
  SaveButton,
  SettingsButton,
  UnlockButton, UploadButton,
  FullScreenButton,
  DetailButton,
  FilterButton
};